// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__vTa9b","header":"ReportDetails_header__2JsH7","title":"ReportDetails_title__1myK8","left":"ReportDetails_left__3aZJ3"};